import { AxiosHeaders, AxiosResponse } from "axios";

const exportFileFromAxiosResponse = (response: AxiosResponse<any, any>) => {
  const { data: fileData } = response;

  let reponseContentType: string | undefined;

  const headers = response.headers;
  if (headers instanceof AxiosHeaders && headers.has("content-type")) {
    reponseContentType = headers["content-type"];
  }

  const downloadFileName = reponseContentType?.replace("application/", "");
  exportFile(fileData, downloadFileName);
};

const exportFile = (fileContent: string, fileName: string | undefined) => {
  const blob = new Blob([fileContent], { type: "text/plain" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.download = fileName ?? "file.txt";
  link.href = url;
  link.click();
  URL.revokeObjectURL(url);
};

const fileService = {
  exportFileFromAxiosResponse,
  exportFile,
};

export default fileService;
